<template>
  <!-- 缺省页提示 -->
  <div>
    <slot name="box">
      <div class="defaulePage" :style="{paddingTop:marginTop,paddingBottom:paddingbottom}">
        <img :style="{width:width,height:height}" :src="imgPath" />

        <slot name="title">
          <div class="title" :style="{marginTop:marginTopSize}">
            <p>{{title}}</p>
          </div>
        </slot>
        <slot name="button"></slot>
      </div>
    </slot>
  </div>
</template>

<script>
export default {
  name: "defaulePage",
  props: {
    marginTopSize: {
      type: String,
      default: "1rem"
    },
    marginTop: {
      type: String,
      default: "3.85rem"
    },
    butmarginTop: {
      type: String,
      default: "1.35rem"
    },
    paddingbottom: {
      type: String,
      default: "0"
    },
    width: {
      type: String,
      default: "auto"
    },
    height: {
      type: String,
      default: "auto"
    },
    title: {
      type: String,
      default: "暂无消息"
    },
    // 图片路径
    imgPath: {
      type: String
    },
  },
  data() {
    return {};
  },
  methods: {
    toIndex() {
      this.$router.push('/index')
    }
  }
}
</script>

<style lang="scss" scoped>
	.defaulePage {
		min-width: 10.55rem;
		height: auto;
		color: #999999;
		text-align: center;
		margin: 0 auto;

    &::-webkit-scrollbar {
      display: none;
    }

		.title {
			color: #8E8E8E;
			font-size: .7rem;
			display: flex;
			align-items: center;
			text-align: center;
			justify-content: center;
			line-height: .7rem;
		}
	}

</style>